export interface TreatmentImplant {
    treatmentId: string;
    abutmentBrand?: string;
    abutmentPartNumber?: string;
    scanBodyBrand?: string;
    scanBodyPartNumber?: string;
}
